import { Divider, Grid, Typography } from '@mui/material';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { TextBoxItem } from 'components/Input/TextBox';
import UploadFileItem from 'components/Input/UploadFile';
import { FormProvider } from 'react-hook-form';
import { Extension } from 'utilities/utilities';
import TableWithdraw from './TableWithdraw';
import { useWithdrawTicketForm } from '../../hooks/useWithdrawTicket';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { SelectItem } from 'components/Input/Select/SelectItem';
import moment from 'moment';

const WithdrawTicketForm = () => {

    const {
        objMuseum,
        onClearAttachFile,
        arrAttachmentList,
        setArrAttachmentList,
        form,
        gotoBack,
        handleSubmitForm,
        lstSeller,
        objParamPath,
        nUserType,
        lstMuseum,
        getTypeTicketMuseum,
        isView
    } = useWithdrawTicketForm()

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} >
                {/* Form */}
                <FormProvider {...form}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            {
                                nUserType === 1 ?
                                    <TextBoxItem
                                        name="sMuseum"
                                        label={"ชื่อพิพิธภัณฑ์"}
                                        maxLength={250}
                                        id={"sMuseum"}
                                        required={true}
                                        type={'text'}
                                        disabled
                                    />
                                    :
                                    <SelectItem
                                        id={"nMuseum"}
                                        name={"nMuseum"}
                                        label={`ชื่อพิพิธภัณฑ์`}
                                        required={nUserType !== 1}
                                        options={lstMuseum}
                                        disabled={objParamPath.ParamId != null || isView}
                                        onChange={(eValue) => {
                                            let nMuseumId = eValue ? eValue.value : null;
                                            getTypeTicketMuseum(nMuseumId, null)
                                        }}
                                    />
                            }
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextBoxItem
                                        name="sOrderBook"
                                        label={"เลขที่ใบเบิก"}
                                        maxLength={10}
                                        id={"sOrderBook"}
                                        required={true}
                                        type={'text'}
                                        IsShowTextCont
                                        disabled={isView}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <DatePickerItem
                                        name={"dTicketWithdrawal"}
                                        id={"dTicketWithdrawal"}
                                        label={`วันที่เบิกตั๋ว`}
                                        fullWidth={true}
                                        required={true}
                                        disabled={objParamPath.ParamId != null}
                                        maxDate={moment()}
                                        onChange={(e) => {
                                            form.setValue("dSold", e)
                                            form.clearErrors("dSold")
                                            let dDate = e ? moment(e).valueOf() : null;
                                            getTypeTicketMuseum(objMuseum.nMuseumID, objMuseum.sMuseumName, dDate)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <DatePickerItem
                                        name={"dSold"}
                                        id={"dSold"}
                                        label={`เบิกเพื่อจำหน่ายตั๋ววันที่`}
                                        fullWidth={true}
                                        required={true}
                                        disabled={objParamPath.ParamId != null}
                                        // maxDate={moment()}
                                        minDate={form.getValues("dTicketWithdrawal") ?? null}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <MultipleSelectItem
                                        id={"arrSeller"}
                                        name={"arrSeller"}
                                        label={`จ่ายให้`}
                                        required={true}
                                        options={lstSeller}
                                        disabled={isView}
                                        limitTag={2}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            <UploadFileItem
                                id="upFile"
                                name={"upFile"}
                                key={"upFile"}
                                label='เอกสารแนบ'
                                IsDrag={true}
                                arrFile={arrAttachmentList}
                                setarrFile={setArrAttachmentList}
                                IsFolder={false}
                                IsMultiple={false}
                                Extension={Extension.FileTicketZip}
                                nLimitFile={30}
                                sLimitFile={"MB"}
                                onClearFile={onClearAttachFile}
                                modeDisplay={"list"}
                                sFolderTemp={"Withdraw"}
                                sPositionText={"right"}
                                required={false}
                                disabled={isView}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <br />
                        </Grid>
                        <Grid item xs={12} >
                            <Typography>หน่วยเป็น : เล่ม</Typography>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} >
                            <TableWithdraw form={form} objMuseum={objMuseum} isEdit={objParamPath.ParamId != null} />
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
            </Grid>

            <Grid item xs={12} >
                {/* Button */}
                <Grid container spacing={2} justifyContent={"center"} alignItems={"start"}>
                    <Grid item>
                        <BtnBack id={"btnback-withdraw"} onClick={() => gotoBack()} />
                    </Grid>
                    {!isView && <Grid item>
                        <BtnSave id={"btnsave-withdraw"} onClick={form.handleSubmit(handleSubmitForm)} />
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default WithdrawTicketForm

